'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduce2 = require('./internal/_reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _set2 = require('./internal/_set');

var _set3 = _interopRequireDefault(_set2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function merge(updates, subject) {
  return (0, _reduce3.default)(subject, function (acc, value, key) {
    return (0, _set3.default)(key, value, acc);
  }, updates);
}

/**
 * Takes each entry of `updates` and sets it on `subject`.
 *
 * @example
 * // returns Map { "one" => 3, "two" => 2, "three" => 1}
 * merge(
 *   Map({one: 1, two: 2, three: 3}),
 *   Map({one: 3, three: 1})
 * );
 *
 * @param  {Iterable} updates key-value pairs to merge in `subject`.
 * @param  {Iterable} subject the thing to update.
 * @return {Iterable} with each key-value of `updates` merged into `subject`.
 */
exports.default = (0, _curry2.default)(merge);
module.exports = exports['default'];